import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";

export const getPrimaryTextCount = async () => {
  return base.get({
    url: `${API_PARAM.PRIMARY_TEXT_COUNT}`,
  });
};

export const exportPrimaryTextGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.PRIMARY_TEXT_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.PRIMARY_TEXT),    
  });
};

export const uploadFromPrimaryText = async () => {
  return base.post({
    url: `${API_PARAM.PRIMARY_TEXT_UPLOAD}`,
  });
};